/**
 * Returns tasks map
 * @param {Object} state the redux store
 * @return {Object} id -> task
 */
export const getTasks = state => state.entities.tasks.entities;
